// User-facing release phase preference values.
export const RELEASE_PHASES = ['beta', 'stable'];
export const DEFAULT_RELEASE_PHASE = 'beta';
export function isReleasePhase(value) {
    return typeof value === 'string' && RELEASE_PHASES.includes(value);
}
export function coerceReleasePhase(value) {
    return isReleasePhase(value) ? value : DEFAULT_RELEASE_PHASE;
}
//# sourceMappingURL=releasePhases.js.map